import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { OperatorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { GoogleMapsIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalLocation extends React.Component<Props> {

	state = {
		item: this.props.item
	}
	
	render() {
		return (
			<div id="modal-view-client-location">
				<div className="container-location">
					{
						this.state.item?.addresses?.map((i: any) => {
							let address = '';
							
							if (i.state) {
								if (address) address += ' - ';
								address += i.state?.name;
							}

							if (i.city) {
								if (address) address += ' - ';
								address += i.city?.name;
							}

							if (i.municipality) {
								if (address) address += ' - ';
								address += i.municipality?.name;
							}

							if (i.address) {
								if (address) address += ' - ';
								address += i.address;
							}

							if (i.information) {
								if (address) address += ' - ';
								address += i.information;
							}

							if (i.indications) {
								if (address) address += ' - ';
								address += i.indications;
							}

							return (
								<div className="item-address">
									<img src={ GoogleMapsIcon } />
									<div>
										<p>{ address }</p>
										{
											i.latitude && i.longitude && (
												<a href={ `https://maps.google.com/?q=${ i.latitude },${ i.longitude }` } target="_blank" className="open-google-maps">
													Enviar a Google Maps
												</a>
											)
										}
									</div>
								</div>
							)
						})
					}
				</div>
				<div className="text-center">
					<Button type="button" onClick={ () => this.props.onClose() }>
						Cerrar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalLocation;